import { render } from "./CoinBundlePage.vue?vue&type=template&id=4bb5c9fd&scoped=true"
import script from "./CoinBundlePage.vue?vue&type=script&lang=js"
export * from "./CoinBundlePage.vue?vue&type=script&lang=js"

import "./CoinBundlePage.vue?vue&type=style&index=0&id=4bb5c9fd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb5c9fd"]])

export default __exports__